import { IsEnum } from 'class-validator';
import { RippleStablecoinCurrency } from '../types';

export class RippleStablecoinRequest {
  @IsEnum(RippleStablecoinCurrency)
  public readonly currency!: RippleStablecoinCurrency;
}
